import { useState } from 'react';
import { FormControl, Glyphicon, InputGroup, Button, Sizes } from 'react-bootstrap';

interface IProps {
    name?: string,
    autoComplete?: string,
    value: string,
    size?: Sizes,
    onChange: (name: string, value: string) => void,
    onKeyPress?: (e: React.KeyboardEvent<FormControl>) => void
}

const PasswordField = (props: IProps) => {
    const [showPassword, setShowPassword] = useState(false);

    // const handleValueChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
    //     props.onChange(props.name, e.currentTarget.value);
    // };

    const handleValueChange = (e: React.FormEvent<HTMLInputElement>) => {
        props.onChange(props.name, e.currentTarget.value);
    };

    const handleChangeView = () => {
        setShowPassword(!showPassword);
    };

    const handleKeyPress = (e: React.KeyboardEvent<FormControl>) => {
        if (props.onKeyPress != null)
            props.onKeyPress(e);
    };

    return (
        <InputGroup bsSize={props.size}>
            {/* <FormControl
                type={!showPassword ? 'password' : 'text'}
                name={props.name}
                autoComplete='new-password'
                value={props.value}
                onChange={handleValueChange}
                onKeyPress={handleKeyPress}
            /> */}
            <input
                type={!showPassword ? 'password' : 'text'}
                className='form-control'
                name={props.name}
                autoComplete={props.autoComplete ? props.autoComplete : 'new-password'}
                aria-autocomplete='none'
                value={props.value}
                onChange={handleValueChange}
            />
            <InputGroup.Button>
                <Button onClick={handleChangeView}><Glyphicon glyph={showPassword ? 'eye-open' : 'eye-close'} /></Button>
            </InputGroup.Button>
        </InputGroup>
    );
}

export default PasswordField;